import axios from 'axios';
import {
  GET_INFOS,
  GET_NEW_INFO,
  GET_DELETED_INFO,
  INFOS_LOADING,
  GET_ERRORS,
  CLEAR_ERRORS,
} from './types';

// Create info
export const createInfo = (infoData, history) => (dispatch) => {
  dispatch(clearInfoErrors());
  axios
    .post('/api/infos', infoData)
    .then((res) => {
      dispatch({
        type: GET_NEW_INFO,
        payload: res.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Edit info
export const editInfo = (infoData, info_id) => (dispatch) => {
  dispatch(clearInfoErrors());
  axios
    .post(`/api/infos/${info_id}`, infoData)
    .then((res) => {
      dispatch({
        type: GET_INFOS,
        payload: res.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Delete info by ID
export const deleteInfoByID = (info_id) => (dispatch) => {
  dispatch(clearInfoErrors());
  axios
    .delete(`/api/infos/${info_id}`)
    .then((res) => {
      dispatch({
        type: GET_DELETED_INFO,
        payload: res.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Get all infos
export const getInfos = () => (dispatch) => {
  dispatch(setInfoLoading());
  axios
    .get('/api/infos/all')
    .then((res) =>
      dispatch({
        type: GET_INFOS,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_INFOS,
        payload: null,
      })
    );
};

// Get info by page id
export const getInfosByPage = (page_id) => (dispatch) => {
  dispatch(clearInfoErrors());
  dispatch(setInfoLoading());
  axios
    .get(`/api/infos/page/${page_id}`)
    .then((res) =>
      dispatch({
        type: GET_INFOS,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_INFOS,
        payload: null,
      })
    );
};

// Info loading
export const setInfoLoading = () => {
  return {
    type: INFOS_LOADING,
  };
};

// Clear errors
export const clearInfoErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
